var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"text-center",attrs:{"variant":"primary","show":"","dismissible":""}},[_vm._v(" 系統查找失效，請重新輸入搜尋代碼或稍待片刻 ")])}
var staticRenderFns = []

export { render, staticRenderFns }